import React from "react";
import Input from "../../../components/FormComponents/Input";
import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";

const ExcelFieldsTable = ({ fieldsArr, setFieldsArr }) => {
  const handleUpdateExcel = (updatedFields) => {
    setFieldsArr(updatedFields);
  };

  return (
    <div className="user_table" style={{ height: "auto", paddingBottom: "0px" }}>
      <table>
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Cell Id</th>
            <th>Overwrite</th>
            <th>Total Columns</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {fieldsArr.length > 0 ? (
            fieldsArr.map((field, index) => (
              <SingleExcelRow
                key={`${field.name}-${index}`}
                field={field}
                fieldsArr={fieldsArr}
                index={index}
                onChange={handleUpdateExcel}
              />
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center", fontSize: "18px" }}>
                No Data Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const SingleExcelRow = ({ index, field, fieldsArr, onChange }) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const [editedField, setEditedField] = React.useState({
    name: field.name,
    cell_id: field.cell_id,
    overwrite: field.overwrite,
    total_columns: field.total_columns
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditedField({
      ...editedField,
      [name]: type === "checkbox" ? checked : name === "total_columns" ? parseInt(value) : value
    });
  };

  const handleSave = () => {
    const updatedFieldsArr = fieldsArr.map((item, i) => (i === index ? { ...field, ...editedField } : item));
    onChange(updatedFieldsArr);
    setIsEditing(false);
  };

  const handleDeleteRow = () => {
    const updatedFieldsArr = fieldsArr.filter((_, i) => i !== index);
    onChange(updatedFieldsArr);
  };

  const handleAddRecordsetCells = () => {
    const sampleObj = { name: "", column_id: "", type: "serialisation" };
    const updatedFieldsArr = fieldsArr.map((item, i) => {
      if (i === index) {
        return {
          ...item,
          cells: item.cells ? [...item.cells, sampleObj] : [sampleObj]
        };
      }
      return item;
    });

    onChange(updatedFieldsArr);
  };

  return (
    <>
      <tr>
        {isEditing ? (
          <>
            <td>{field.type}</td>
            <td>
              <Input name="name" value={editedField.name} onChange={handleInputChange} />
            </td>
            <td>
              <Input name="cell_id" value={editedField.cell_id} onChange={handleInputChange} />
            </td>
            <td>
              <Input type="checkbox" name="overwrite" checked={editedField.overwrite} onChange={handleInputChange} />
            </td>
            <td>
              {field.type === "recordset-list" ? (
                <Input
                  type="number"
                  name="total_columns"
                  value={editedField.total_columns}
                  onChange={handleInputChange}
                />
              ) : (
                <>-</>
              )}
            </td>
            <td>
              <ButtonActionIcon type="save" onClick={handleSave} />
            </td>
          </>
        ) : (
          <>
            <td>{field.type}</td>
            <td>{field.name}</td>
            <td>{field.cell_id}</td>
            <td>{field.overwrite === true ? "yes" : "no"}</td>
            <td>{field.total_columns || <>-</>}</td>
            <td>
              <div className="icons">
                <ButtonActionIcon type="edit" onClick={() => setIsEditing(true)} />
                <ButtonActionIcon type="delete" onClick={handleDeleteRow} />
                {field.type === "recordset-list" && (
                  <ButtonActionIcon type="add" title="Add cells" onClick={handleAddRecordsetCells} />
                )}
              </div>
            </td>
          </>
        )}
      </tr>

      {/* Nested cells if recordset-list */}
      {field.type === "recordset-list" && field?.cells?.length > 0 && (
        <tr>
          <td colSpan="6">
            <div className="user_table" style={{ height: "auto", paddingBottom: "0px" }}>
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Column Id</th>
                    <th>Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {field.cells.map((cell, cellIndex) => (
                    <RecordsetCellRow
                      key={`${cellIndex}-${cell.name}`}
                      cellIndex={cellIndex}
                      cell={cell}
                      fieldIndex={index}
                      fieldsArr={fieldsArr}
                      onChange={onChange}
                      parentField={field}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

const RecordsetCellRow = ({ cellIndex, cell, fieldIndex, fieldsArr, onChange }) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const [editedCell, setEditedCell] = React.useState({
    name: cell.name.split(".")[1] || "",
    column_id: cell.column_id,
    type: cell.type
  });

  const handleInputChange = (name, value) => {
    setEditedCell({
      ...editedCell,
      [name]: name === "column_id" ? parseInt(value) : value
    });
  };

  const handleSave = () => {
    const updatedFieldsArr = fieldsArr.map((field, i) => {
      if (i === fieldIndex) {
        const updatedCells = field.cells.map((c, ci) =>
          ci === cellIndex ? { ...editedCell, name: `${field.name}.${editedCell.name}` } : c
        );
        return { ...field, cells: updatedCells };
      }
      return field;
    });

    onChange(updatedFieldsArr);
    setIsEditing(false);
  };

  const handleDeleteCell = () => {
    const updatedFieldsArr = fieldsArr.map((field, i) => {
      if (i === fieldIndex) {
        const updatedCells = field.cells.filter((_, idx) => idx !== cellIndex);
        return { ...field, cells: updatedCells };
      }
      return field;
    });

    onChange(updatedFieldsArr);
  };

  const cellTypeOptions = [{ id: "serialisation", name: "serialisation" }];

  return (
    <tr>
      {isEditing ? (
        <>
          <td>
            <Input name="name" value={editedCell.name} onChange={(e) => handleInputChange("name", e.target.value)} />
          </td>
          <td>
            <Input
              type="number"
              name="column_id"
              value={editedCell.column_id}
              onChange={(e) => handleInputChange("column_id", e.target.value)}
            />
          </td>
          <td>
            <SingleSelectBox
              selectedData={editedCell.type}
              options={cellTypeOptions}
              onChange={(obj) => handleInputChange("type", obj.id)}
            />
          </td>
          <td>
            <ButtonActionIcon type="save" onClick={handleSave} />
          </td>
        </>
      ) : (
        <>
          <td>{cell.name}</td>
          <td>{cell.column_id}</td>
          <td>{cell.type}</td>
          <td>
            <div className="icons">
              <ButtonActionIcon type="edit" onClick={() => setIsEditing(true)} />
              <ButtonActionIcon type="delete" onClick={handleDeleteCell} />
            </div>
          </td>
        </>
      )}
    </tr>
  );
};

export default ExcelFieldsTable;
